import SearchStore from '../store/schema/SearchStore';
import shallowClearSearchStore from '../actions/shallowClearSearchStore';
import { getStore as getSearchStore } from '../store/Store';
import { mutator } from 'satcheljs';

/**
 * Mutator which clears the guids and suggestions present
 * in the store
 * However zeroQuerySuggestions are not to be cleared for optimisations and caching purposes
 */
export default mutator(
    shallowClearSearchStore,
    function shallowClearSearchStoreMutator(actionMessage: {}) {
        const searchStore: SearchStore = getSearchStore();
        searchStore.searchSessionGuid = null;
        searchStore.conversationGuid = null;
        searchStore.suggestions = null;
    }
);
